export const STORAGE_ANALYTIC_ID_KEY = "do-user-analytic-id";
export const STORAGE_SESSION_ID_KEY = "do-user-session-id";
export const STORAGE_HISTORY_IDX_KEY = "historyIdx";
export const FAKE_PREVIEW_SCENARIO_SESSION_ID = "34bz3gyb315df4a0cd8992e3";
